import axios from "axios"
export function deleteAdvertisementCampaign(token, advertiserId) {
    return axios.get(process.env.REACT_APP_API_URL + `/deleteAdvertisement?advertisementId=${advertiserId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}